import React, { useState, useEffect } from 'react';
import { MegaMenu } from 'primereact/megamenu';
import { Link, useNavigate } from 'react-router-dom';
import './navbar.css'
import logo from '../Assets/opal-nutrition.png'
import { TbShoppingBagSearch } from "react-icons/tb";
import { MdOutlineAccountCircle } from "react-icons/md";
import { IoIosArrowDown } from "react-icons/io";
import { useAuth } from '../../Context/AuthContext';
import { IoMdMenu, IoMdClose, IoIosArrowForward } from "react-icons/io";
import SearchBar from '../../Pages/SearchBar';

export default function Navbar() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth <= 991);
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);

useEffect(() => {
  if (mobileMenuOpen && isMobile) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = 'auto';
  }
}, [mobileMenuOpen, isMobile]);

const [brands, setBrands] = useState([]);

useEffect(() => {
  fetch('/api/brands.php?action=list')
    .then(res => res.json())
    .then(data => setBrands(data))
    .catch(() => setBrands([]));
}, []);

    const items = [
        {
            label: 'Accueil', command:() => navigate('/'),
        },
        {
            label: 'Produits',
            icon: 'pi pi-box',
            items: [
                
                [
                    {
                        label: 'Alimentation Saine',
                        items: [{ label: 'Barres et Snacks', command:() => navigate('/categorie/barres-snacks')}, { label: 'Boissons', command:() => navigate('/categorie/boissons')}, { label: 'Petit Déjeuner', command:() => navigate('/categorie/petit-dejeuner') }, { label: 'Farines, Céréales', command:() => navigate('/categorie/farines-cereales') }, { label: 'Déjeuner et Diner', command:() => navigate('/categorie/dejeuner-diner') }, { label: 'Sauces, Sirops, Confitures', command:() => navigate('/categorie/sauces-sirops-confitures')}, { label: 'Beurre de cacahuète', command:() => navigate('/categorie/beurre-de-cacahuete') }, { label: 'Pâte à tartiner', command:() => navigate('/categorie/pate-a-tartiner') }]
                    }
                ],
                [
                    {
                        label: 'Nutrition',
                        items: [{ label: 'Protéines', command:() => navigate('/categorie/proteines') }, { label: 'Développement musculaire', command:() => navigate('/categorie/developpement-musculaire') }, { label: 'Energie et endurance', command:() => navigate('/categorie/energie-endurance') }, { label: 'Bruleur de graisse', command:() => navigate('/categorie/bruleur-de-graisse') }, { label: 'Récupération', command:() => navigate('/categorie/recuperation') }, { label: 'Pré-workout', command:() => navigate('/categorie/pre-workout') }]
                    }
                ],
                [
                    {
                        label: 'Santé et Minceur',
                        items: [{ label: 'Perte de poids', command:() => navigate('/categorie/perte-de-poids') }, { label: 'Santé', command:() => navigate('/categorie/sante') }, { label: 'Vitamines, Minéraux, Herbes', command:() => navigate('/categorie/vitamines-mineraux-herbes') }]
                    }
                ],
                [
                    {
                        label: 'Packs',
                        items: [{ label: 'Nos Packs', command:() => navigate('/categorie/nos-packs') }]
                    }
                ],
            ]
        },
        {
            label: 'Equipements',
            icon: 'pi pi-mobile',
            items: [
                [
                    {
                        label: 'Fitness',
                        items: [{ label: 'Manique', command:() => navigate('/categorie/manique') }, { label: 'Corde à sauter', command:() => navigate('/categorie/corde-a-sauter') }, { label: 'Genouillère', command:() => navigate('/categorie/genouillere') }, { label: 'Poignet de force/Sangle de tirage', command:() => navigate('/categorie/poigner-force') }, { label: 'Shaker', command:() => navigate('/categorie/shaker') }]
                    }
                ],
                [
                    {
                        label: 'Rugby',
                        items: [{ label: 'Protège dents', command:() => navigate('/categorie/protege-dents') }, { label: 'Pour le rasage', command:() => navigate('/categorie/rasage') }, { label: 'Casque', command:() => navigate('/categorie/casque') }]
                    }
                ]
            ]
        },
        {
            label: 'Vêtements',
            icon: 'pi pi-clock',
            items: [
                [
                    {
                        label: 'Fitness',
                        items: [{ label: 'Maillot', command:() => navigate('/categorie/fitness-maillot') }, { label: 'Pull/Veste', command:() => navigate('/categorie/fitness-pull-veste') }, { label: 'Short', command:() => navigate('/categorie/fitness-short') }, { label: 'Jogging', command:() => navigate('/categorie/fitness-jogging') }, { label: 'Chaussettes', command:() => navigate('/categorie/fitness-chaussettes') }, { label: 'Chaussures', command:() => navigate('/categorie/fitness-chaussures') }]
                    }
                ],
                [
                    {
                        label: 'Rugby',
                        items: [{ label: 'Maillot', command:() => navigate('/categorie/rugby-maillot') }, { label: 'Pull/Veste', command:() => navigate('/categorie/rugby-pull-veste') }, { label: 'Short', command:() => navigate('/categorie/rugby-short') }, { label: 'Jogging', command:() => navigate('/categorie/rugby-jogging') }, { label: 'Chaussettes', command:() => navigate('/categorie/rugby-chaussettes') }, { label: 'Crampons', command:() => navigate('/categorie/rugby-crampons') }, { label: 'Ensemble', command:() => navigate('/categorie/rugby-ensemble') }]
                    }
                ]
            ]
        },
        {
            label: 'Nos marques',
            icon: 'pi pi-clock',
            items: [
                [
                    {
                        label: 'Nos marques',
                        items: brands.map(b => ({
                          label: b.brand_name,
                          command: () => navigate(`/categorie/${b.brand_key}`)
                        }))
                    }
                ]
            ]
        },
        {
            label: 'Promo', command:() => navigate('/promo'),
        }
    ];

    const [openIndexes, setOpenIndexes] = useState([]);
    const toggleSubMenu = (index) => {
      setOpenIndexes(prev =>
        prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
      );
    };

    return <>

        <div className="navbar">
            <div className="nav-hamburger" onClick={() => setMobileMenuOpen(true)}>
                <IoMdMenu size={30} />
            </div>
            <div className="nav-logo">
                <Link to='/'>
                    <img className='logo-size' src={logo} alt="" />
                </Link>
            </div>
            
                {!isMobile && <MegaMenu className='nav-menu-items' model={items} />}
                <SearchBar />
            <div className="nav-login-shop">
        {user ? (
            <Link to="/compteClient">
                <div className='deco' style={{fontSize: '18px'}}>Bienvenue, {user.username} <IoIosArrowDown /></div>
            </Link>
        ) : (
            <Link to="/login">
                <button className='icon-login'>
                    Se connecter <MdOutlineAccountCircle className="log-icon" />
                </button>
            </Link>
        )}
                <Link to='/CartItems'><TbShoppingBagSearch className='shop-icon' /></Link>
                {/*<div className="nav-cart-count">0</div>*/}
            </div>

        </div>
        {mobileMenuOpen && (
          <div className="mobile-overlay">
            <div className="overlay-header">
              <IoMdClose size={30} onClick={() => setMobileMenuOpen(false)} />
            </div>
            <div className="overlay-menu">
              {items.map((item, idx) => (
                <div key={idx} className="overlay-item">
                  {item.items ? (
                    <>
                      <div className="overlay-parent" onClick={() => toggleSubMenu(idx)}>
                        {item.label} 
                        {openIndexes.includes(idx) ? <IoIosArrowDown /> : <IoIosArrowForward />}
                      </div>
                      {openIndexes.includes(idx) && (
                        <div className="overlay-submenu">
                          {item.items.flat().map((subgroup, sIdx) => (
                            <div key={sIdx} className="overlay-subgroup">
                              {/* Titre du groupe (ex: Alimentation Saine) */}
                              <div className="overlay-subgroup-title">{subgroup.label}</div>
                          
                              {/* Les sous-items */}
                              {subgroup.items.map((subItem, subI) => (
                                <div
                                  key={subI}
                                  className="overlay-subitem"
                                  onClick={() => {
                                    if (subItem.command) subItem.command();
                                    setMobileMenuOpen(false);
                                  }}
                                >
                                  {subItem.label}
                                </div>
                              ))}
                            </div>
                          ))}
                        </div>
                      )}
                    </>
                    ) : (
                      <div onClick={() => {if (item.command) item.command(); setMobileMenuOpen(false);}}>
                        {item.label}
                      </div>
                    )}
                </div>
              ))}
            </div>
          </div>
)}
        
    </>
}